import { jsonldAggregateRatingValue } from './JsonldStore';

export const updateJsonldAggregateRatingValue = (value) => jsonldAggregateRatingValue.update((oldValue) => value);
